module.exports = __webpack_public_path__ + "static/media/dribble.db57da79.svg";